import React, { Fragment } from 'react'
import { Intro, DragAndDrop } from 'cvs-core'
import image from '../../assets/images/U1-T1-14e.svg'

const dragOptions = [
  'He could explain, “I need to get home. I’m going to play soccer with my brother.”',
  'He could say, “No thanks.”',
  'He could talk to his dad, or other trusted adult, about how best to deal with the situation.',
  'He could tell his friends, “I’m not going to vape because vaping can hurt my lungs.”',
  'He could say, “My mom said I have to watch my little sister tonight. Gotta go!”',
  'He could talk to his school counselor about what to do.',
]

const DIRECT_REFUSAL = 'Direct Refusal'
const EXIT_STRATEGY = 'Exit Strategy'
const PROVIDE_INFORMATION = 'Provide Information'
const HUMAN_RESOURCES = 'Human Resources'

const dropZones = [
  DIRECT_REFUSAL,
  EXIT_STRATEGY,
  PROVIDE_INFORMATION,
  HUMAN_RESOURCES,
]

const dropZoneMessage = 'Drag elements here.'

const question =
  "A group of Alex’s friends have been vaping when they get off the bus in the afternoons after school. They keep asking him to try it. There are many ways in which he could refuse. Drag each element to classify the ways in which Alex could say 'no' by the type of resource."

const data = {
  dragOptions,
  dropZones,
  dropZoneMessage,
  question,
}
const correctInput = {
  [DIRECT_REFUSAL]: [dragOptions[1]],
  [EXIT_STRATEGY]: [dragOptions[0], dragOptions[4]],
  [PROVIDE_INFORMATION]: [dragOptions[3]],
  [HUMAN_RESOURCES]: [dragOptions[2], dragOptions[5]],
}

const feedback = {
  success: {
    title: 'Good job!',
    body: '',
  },
  error: {
    title: 'That’s not correct.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 5',
  path: '/challenge/question-5',
  content: (
    <Fragment>
      <Intro title="Question 5" img={image} />
      <DragAndDrop
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question5.js